<template>
    <Background
        :backPath="'/home'">
        <div v-if="fetching">
            <a-spin
                size="large"/>
        </div>
        <div v-else>
            <div
                v-if="reviewAmount > 0"
                class="layout">
                <div class="left-area">
                    <div class="image-area">
                        <div
                            v-for="(item, index) in commodityInfos"
                            :key="index">
                            <Commodity
                                ref="commodity"
                                :commodityImageUrl="item.image"
                                :commodityDescription="item.description"
                                :commodityIndex="index"
                            />
                        </div>
                    </div>
                    <div class="remain-number">
                        还需要审核 {{ reviewAmount - 1 }} 件商品
                    </div>
                </div>
                <div class="right-panel">
                    <div class="commodity-name">{{ commodityName }}</div>
                    <div class="commodity-package-type">{{ packageType }}</div>

                    <div
                        v-if="needReviewToday"
                        class="today-finish">
                        今日必须审核
                    </div>
                    <div
                        v-else
                        class="not-today">
                        可明日审核
                    </div>

                    <GlobalTag ref="globaltag"/>

                    <a-icon
                        v-on:click="commodityConfirm"
                        class="confirm-button"
                        theme="filled"
                        type="right-circle" />

                    <a-input
                        v-model="leaveMessage"
                        placeholder="留言给商家"
                        type="textarea"
                        size="large"/>

                    <div class="business-name">
                        上传者 {{ businessName }}
                    </div>

                    <div class="business-phone">
                        电话 {{ businessPhone }}
                    </div>

                </div>
            </div>
            <div v-else>
                <div
                    v-if="clickReviewButton"
                    class="title">
                    所有商品已审核完毕
                </div>
                <div
                    v-else
                    class="title">
                    没有可审核商品
                </div>
                <a-button
                    v-on:click="returnHome"
                    class="return-button"
                    type="primary"
                    size="large">
                    返回首页
                </a-button>
            </div>
        </div>
    </Background>
</template>

<script>
 import Vue from 'vue';
 import Background from "./Background.vue"
 import Commodity from "./Commodity.vue"
 import GlobalTag from "./GlobalTag.vue"
 import Spin from "ant-design-vue/lib/spin";
 import Icon from "ant-design-vue/lib/icon";
 import Button from "ant-design-vue/lib/button";
 import Input from "ant-design-vue/lib/input";
 import Modal from "ant-design-vue/lib/modal";

 Vue.component(Spin.name, Spin);
 Vue.component(Icon.name, Icon);
 Vue.component(Button.name, Button);
 Vue.component(Input.name, Input);
 Vue.component(Modal.name, Modal);

 export default {
     name: 'CommodityReview',
     data() {
         return {
             commodityId: -1,
             commodityName: "",
             packageId: -1,
             packageType: "",
             commodityInfos: [],
             needReviewToday: false,
             reviewAmount: 0,
             clickReviewButton: false,
             leaveMessage: "",
             businessName: "",
             businessPhone: "",
             fetching: true,
         }
     },
     components: {
         Background,
         Commodity,
         GlobalTag
     },
     methods: {
         commodityConfirm() {
             this.clickReviewButton = true

             var commodityTagInfos = this.$refs.commodity.sort((a, b) => {
                 return a.commodityIndex - b.commodityIndex
             })

             var commodityProblems = []

             for (var i = 0; i < commodityTagInfos.length; i++) {
                 commodityProblems.push(
                     commodityTagInfos[i].commodityTags.filter((e) => {
                         return e.active
                     }).map((e) => {
                         return e.name
                     })
                 )
             }

             var globalProblems = this.$refs.globaltag.tags.filter((e) => {
                 return e.active
             }).map((e) => {
                 return e.name
             })

             var result = {
                 commodityProblems: commodityProblems,
                 globalProblems: globalProblems,
                 leaveMessage: this.leaveMessage
             }

             var reviewPass = true

             if (reviewPass) {
                 for (var j = 0; j < commodityProblems.length; j++) {
                     if (commodityProblems[j].length > 0) {
                         reviewPass = false
                         break
                     }
                 }
             }

             if (reviewPass) {
                 if (globalProblems.length > 0 || this.leaveMessage != "") {
                     reviewPass = false
                 }
             }

             console.log(result)

             const modal = Modal.confirm();
             var that = this
             if (reviewPass) {
                 modal.update({
                     title: that.commodityName,
                     content: '商品通过审核',
                     centered: true,
                     okText: "确认",
                     cancelText: "取消",
                     onOk() {
                         const url = `${process.env.VUE_APP_API_SERVER}/commodity-review/${that.commodityId}`;
                         var data = {
                             Ok: true,
                             Msg: ""
                         };
                         var accessToken = localStorage.getItem('accessToken')

                         fetch(url, {
                             method: 'PUT',
                             body: JSON.stringify(data), // data can be `string` or {object}!
                             headers: new Headers({
                                 'Content-Type': 'application/json',
                                 'Access-Token': accessToken
                             })
                         }
                         ).then(res => res.json()
                         ).catch(error => {
                             console.log("Error: ", error)
                         }).then(response => {
                             console.log(response)

                             that.fetchReviewCommodity()
                         })
                     }
                 })
             } else {
                 modal.update({
                     title: that.commodityName,
                     content: '商品不能通过审核',
                     centered: true,
                     okText: "确认",
                     cancelText: "取消",
                     onOk() {
                         const url = `${process.env.VUE_APP_API_SERVER}/commodity-review/${that.commodityId}`;
                         var data = {
                             Ok: false,
                             Msg: JSON.stringify(result)
                         };
                         var accessToken = localStorage.getItem('accessToken')

                         fetch(url, {
                             method: 'PUT',
                             body: JSON.stringify(data), // data can be `string` or {object}!
                             headers: new Headers({
                                 'Content-Type': 'application/json',
                                 'Access-Token': accessToken
                             })
                         }
                         ).then(res => res.json()
                         ).catch(error => {
                             console.log("Error: ", error)
                         }).then(response => {
                             console.log(response)

                             that.fetchReviewCommodity()
                         })
                     },
                 })
             }
         },

         returnHome() {
             this.$router.replace("/home")
         },

         fetchReviewCommodity() {
             this.fetching = true

             const url = `${process.env.VUE_APP_API_SERVER}/commodity-review`;
             var accessToken = localStorage.getItem('accessToken')

             fetch(url, {
                 method: 'GET',
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                 console.log("Error: ", error)
             }).then(response => {
                 console.log(response)

                 this.reviewAmount = response.Amount

                 if (this.reviewAmount > 0) {
                     var firstCommodity = response.Commodity
                     var commodityInfos = []

                     for (var i = 0; i < firstCommodity.Images.length; i++) {
                         commodityInfos.push({
                             image: firstCommodity.Images[i],
                             description: ""
                         })
                     }

                     this.commodityId = firstCommodity.CommodityId
                     this.commodityName = firstCommodity.Name
                     this.packageId = firstCommodity.PackId
                     this.commodityInfos = commodityInfos
                     this.businessName = response.UploadBy && response.UploadBy.Username
                     this.businessPhone = response.UploadBy && response.UploadBy.Phone

                     /* 切换商品时重新初始化信息 */
                     if (this.$refs.length > 0) {
                         var commodites = this.$refs.commodity
                         for (var j = 0; j < commodites.length; j++) {
                             commodites[j].reset()
                         }

                         this.$refs.globaltag.reset()
                     }

                     var now = new Date()
                     var submissionDate = new Date(Date.parse(firstCommodity.CreatedAt))
                     var timeDiff = now.getTime() - submissionDate.getTime();
                     var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

                     this.needReviewToday = diffDays > 1

                     this.leaveMessage = ""

                     this.fetchCommodityMetadata()
                 }

                 this.fetching = false
             });
         },

         fetchCommodityMetadata() {
             const url = `${process.env.VUE_APP_API_SERVER}/commodity-metadata`;
             var accessToken = localStorage.getItem('accessToken')

             fetch(url, {
                 method: 'GET',
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                 console.log("Error: ", error)
             }).then(response => {
                 console.log(response)

                 for (var i = 0; i < response.Packs.length; i++) {
                     if (this.packageId == response.Packs[i].PackId) {
                         this.packageType = response.Packs[i].Name

                         for (var j = 0; j < response.Packs[i].Descriptions.length; j++) {
                             if (this.commodityInfos[j]) {
                                 this.commodityInfos[j].description = response.Packs[i].Descriptions[j]
                             } else {
                                 console.log("获取商品 description 时出错", this.commodityInfos)
                             }
                         }

                         break
                     }
                 }
             });
         }
     },
     mounted() {
         this.fetchReviewCommodity()
     }
 }
</script>

<style scoped>
 .layout {
     display: flex;
     flex-direction: row;
     align-items: center;
 }

 .image-area {
     display: flex;
     flex-direction: row;
     align-items: center;
 }

 .left-area {
     height: 100%;
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
 }

 .right-panel {
     height: 100%;
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
     padding-top: 30px;
     padding-bottom: 30px;
     padding-left: 40px;
 }

 .commodity-name {
     font-size: 20px;
 }

 .commodity-package-type {
     font-size: 18px;
 }

 .confirm-button {
     font-size: 60px;
     color: #AAA;
     margin-bottom: 40px;
 }

 .confirm-button:hover {
     color: #56A29B;
 }

 .remaining-number {
     font-size: 10px;
     margin-top: 20px;
     color: #AAA;

     position: absolute;
     bottom: 10px;
 }

 .today-finish {
     margin-top: 15px;
     margin-bottom: 10px;
     color: #D80E3B;

     display: block;
 }

 .not-today {
     margin-top: 15px;
     margin-bottom: 10px;
     color: #333;

     display: block;
 }

 .title {
     font-size: 30px;
     color: #666;
 }

 .return-button {
     margin-top: 20px;
 }

 .remain-number {
     color: #999;
     font-size: 20px;
     margin-top: 40px;
 }

 .business-name {
     font-size: 14px;
     color: #999;
     align-self: start;
     margin-top: 10px;
 }

 .business-phone {
     font-size: 14px;
     color: #999;
     align-self: start;
 }
</style>
